import { render, staticRenderFns } from "./MyHabits.vue?vue&type=template&id=1a2516b6"
import script from "./MyHabits.vue?vue&type=script&lang=js"
export * from "./MyHabits.vue?vue&type=script&lang=js"
import style0 from "./MyHabits.vue?vue&type=style&index=0&id=1a2516b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports